import MenuComponent from '@/components/MenuComponent'

import OubliLogin from '@/models/credentialssearch.model'

export default {
  components: {
    MenuComponent
  },

  data () {
    return {
      oubliLogin: new OubliLogin(),
      isCardHolderChecked: true,
      isCardManagerChecked: false,
      showForm: true,
      isFormCompleted: false,
      isResultOK: false,
      login: '',
      validationMessage: [],
      errorMessage: ''
    }
  },

  created () {
    this.oubliLogin.isCardHolder = true
  },

  methods: {
    displayForm (role) {
      if (role === 'Titulaire') {
        var cardHolder = document.querySelector('input[id="carteTitulaire"]:checked')
        if (cardHolder != null) {
          this.oubliLogin.isCardHolder = true
          this.isCardHolderChecked = true
          this.isCardManagerChecked = false
        }
      } else if (role === 'Gestionnaire') {
        var cardManager = document.querySelector('input[id="carteGestionnaire"]:checked')
        if (cardManager != null) {
          this.oubliLogin.isCardHolder = false
          this.isCardManagerChecked = true
          this.isCardHolderChecked = false
        }
      }
    },

    rechercheIdentifiant () {
      this.showForm = false
      this.$store.dispatch('credentials/searchLogin', this.oubliLogin).then(
        reponseLogin => {
          this.isResultOK = true
          this.login = reponseLogin
        },
        error => {
          this.isResultOK = false
          this.errorMessage = error.response
        }
      )
    },

    validationFormulaire () {
      this.validationMessage = []
      if (!this.oubliLogin.lastName || this.oubliLogin.lastName === '') {
        this.validationMessage[0] = 'Le nom doit être renseigné'
      }
      if (!this.oubliLogin.firstName || this.oubliLogin.firstName === '') {
        this.validationMessage[1] = 'Le prénom doit être renseigné'
      }
      if (this.isCardHolderChecked && (!this.oubliLogin.lastThreeDigitsPan || this.oubliLogin.lastThreeDigitsPan === '')) {
        this.validationMessage[2] = 'Les trois derniers chiffres du numéro de carte doivent être renseignés'
      }
      if (this.isCardManagerChecked) {
        if (!this.oubliLogin.siret || this.oubliLogin.siret === '') {
          this.validationMessage[3] = 'Le siret doit être renseigné'
        }
        if ((!this.oubliLogin.entityName || this.oubliLogin.entityName === '') && (!this.oubliLogin.entityId || this.oubliLogin.entityId === '')) {
          this.validationMessage[4] = 'Le nom de votre entité OU votre numéro contrat doit être renseigné'
        }
        if (this.oubliLogin.entityName && this.oubliLogin.entityId) {
          this.validationMessage[4] = 'Renseignez SOIT le numéro de contrat SOIT le nom de votre entité, pas les deux'
        }
        if (this.oubliLogin.entityId && this.oubliLogin.entityId.substring(0, 1) !== 'E') {
          this.validationMessage[5] = 'Le format du numéro de contrat ne correspond pas à celui attendu. (Ex : E5423)'
        }
      }
      if (this.validationMessage.length === 0) {
        if (this.oubliLogin.entityId) {
          this.oubliLogin.entityId = this.oubliLogin.entityId.substring(1)
        }
        this.isFormCompleted = true
        this.rechercheIdentifiant()
      }
    }
  }
}
